import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ShareNetwork } from '@phosphor-icons/react';

// SOCIAL-RECONNECT-REMINDER-001: shown at most once per project, the very
// first time the mainboard opens after the wizard, only when no social
// account was connected during Step 1. Purely informational — never a
// blocker: generating content never requires a connected account, only
// publishing does. Either action (go connect / dismiss) marks the
// reminder as shown so it never reappears for this project; App.js then
// derives the persistent bell/Connections-icon dot from whether the
// project still has zero connected accounts after this point.
export default function SocialConnectReminderModal({ onDismiss, onGoToConnections }) {
  const { t } = useTranslation();

  return (
    <div
      className="fixed inset-0 z-[220] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.7)' }}
      onClick={onDismiss}
      data-testid="social-reminder-modal"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="card w-full max-w-md p-5"
        onClick={e => e.stopPropagation()}
      >
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center mb-3"
          style={{ background: 'rgba(124,92,255,0.12)' }}
        >
          <ShareNetwork size={20} weight="bold" color="var(--gradient-start)" />
        </div>
        <h3 className="font-semibold text-lg mb-1">{t('socialReminder.title')}</h3>
        <p className="text-sm text-[var(--text-secondary)] mb-5">{t('socialReminder.body')}</p>

        <div className="flex gap-2">
          <button
            className="btn-ghost flex-1"
            onClick={onDismiss}
            data-testid="social-reminder-dismiss-btn"
          >
            {t('socialReminder.dismissCta')}
          </button>
          <button
            className="btn-gradient flex-1"
            onClick={onGoToConnections}
            data-testid="social-reminder-connect-btn"
          >
            {t('socialReminder.connectCta')}
          </button>
        </div>
      </motion.div>
    </div>
  );
}
